module.exports = __webpack_public_path__ + "static/the-unforged-089f10bc8a5d24e15cb44d32fe4cde1d.png";